import { z } from 'src/lib';
import { OperacionNOTESFields } from './fields';
import { schemaEntityWithId } from 'src/types';
import { schemaStringOpcional } from 'src/pages/sistema/types/types';

export const schemaOperacionNOTES = z
    .object({
        [OperacionNOTESFields.CodPais]: z.number(),
        [OperacionNOTESFields.NombrePais]: z.string(),
        [OperacionNOTESFields.CodUnidadNegocio]: z.number(),
        [OperacionNOTESFields.UnidadNegocio]: z.string(),
        [OperacionNOTESFields.CodSectorComercial]: z.number(),
        [OperacionNOTESFields.SectorComercial]: z.string(),
        [OperacionNOTESFields.FechaSolicitud]: z.coerce.date(),
        [OperacionNOTESFields.FechaVencimiento]: z.coerce.date(),
        [OperacionNOTESFields.CodEstado]: z.number(),
        [OperacionNOTESFields.DescEstado]: z.string(),
        [OperacionNOTESFields.FechaAprobacion]: z.coerce.date(),
        [OperacionNOTESFields.FechaAlta]: z.coerce.date(),
        [OperacionNOTESFields.IdUsuarioAlta]: z.number(),
        [OperacionNOTESFields.NombreUsuarioAlta]: z.string(),
        [OperacionNOTESFields.ApellidoUsuarioAlta]: z.string(),
        [OperacionNOTESFields.MailUsuarioAlta]: z.string(),

        [OperacionNOTESFields.TipoNota]: z.string(),
        [OperacionNOTESFields.CapitalASuscribir]: z.string(),
        [OperacionNOTESFields.Moneda]: z.string(),
        [OperacionNOTESFields.Vencimiento]: z.string(),
        [OperacionNOTESFields.FechaEmision]: z.coerce.date(),
        [OperacionNOTESFields.Emisor]: z.string(),
        [OperacionNOTESFields.Subyacentes]: z.string(),
        [OperacionNOTESFields.ObsSubyacentes]: z.string(),

        [OperacionNOTESFields.Cupon]: schemaStringOpcional,
        [OperacionNOTESFields.FrecuenciaPago]: schemaStringOpcional,
        [OperacionNOTESFields.CondicionPago]: schemaStringOpcional,
        [OperacionNOTESFields.ObsCupon]: schemaStringOpcional,

        [OperacionNOTESFields.Participacion]: schemaStringOpcional,
        [OperacionNOTESFields.FormaParticipacion]: schemaStringOpcional,
        [OperacionNOTESFields.DescripcionParticipacion]: schemaStringOpcional,
        [OperacionNOTESFields.ObsParticipacion]: schemaStringOpcional,

        [OperacionNOTESFields.TipoProteccion]: z.string(),
        [OperacionNOTESFields.NivelProteccion]: z.string(),
        [OperacionNOTESFields.DescripcionProteccion]: z.string(),
        [OperacionNOTESFields.ObsProteccion]: z.string(),

        [OperacionNOTESFields.BarreraRescateAnticipado]: schemaStringOpcional,
        [OperacionNOTESFields.CondicionRescateAnticipado]: schemaStringOpcional,
        [OperacionNOTESFields.FrecuenciaObservacion]: schemaStringOpcional,
        [OperacionNOTESFields.ObsRescateAnticipado]: schemaStringOpcional,


        [OperacionNOTESFields.TieneCupon]: z.boolean(),
        [OperacionNOTESFields.TieneParticipacion]: z.boolean(),
        [OperacionNOTESFields.TieneRescateAnticipado]: z.boolean(),

        [OperacionNOTESFields.ArchivoGrafico]: z.string().nullable(),

        [OperacionNOTESFields.EstadoFinalizado]: z.boolean(),
        [OperacionNOTESFields.PermiteEditarOperacion]: z.boolean(),
        [OperacionNOTESFields.PermiteEliminarOperacion]: z.boolean(),
        [OperacionNOTESFields.IdMensaje]: z.number()
    })
    .merge(schemaEntityWithId);

export type OperacionNOTES = z.infer<typeof schemaOperacionNOTES>;